import { DashboardApi } from "@asd/customer-portal-api";
import { Moment } from "moment-timezone";

import { axiosInstance } from ".";

export class DashboardService {
  static instance: DashboardService;
  private dashboardApi;

  constructor() {
    if (DashboardService.instance) {
      return DashboardService.instance;
    }

    if (axiosInstance) {
      this.dashboardApi = new DashboardApi(undefined, undefined, axiosInstance);

      DashboardService.instance = this;
    }
  }

  public async getData(startDate: Moment, stopDate: Moment, participantId?: string, providerIds?: string[], options: object = {}) {
    if (!this.dashboardApi) {
      throw new Error("dashboardApi is not initialized");
    }

    try {
      const response = await this.dashboardApi.getDashboardData(
        startDate.format("YYYY-MM-DD"),
        stopDate.format("YYYY-MM-DD"),
        participantId?.length ? participantId : undefined,
        providerIds?.length ? providerIds : undefined,
        options,
      );
      return response;
    } catch {
      // do nothing
    }
  }
}

export default new DashboardService();
